"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from "react";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import { type ProposalFormValues, projectTypeOptions } from "@/lib/proposal";
import { ProposalChoiceCard } from "./proposal-choice-card";
import { proposalChoiceGroupClassName } from "./proposal-form-constants";
const typeIcons = {
  Site: (props: {
    className?: string;
  }) => <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={props.className}>
			<title>Site</title>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M19.5 7a9 9 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4" />
			<path d="M11.5 3a16.989 16.989 0 0 0 -1.826 4" />
			<path d="M12.5 3a16.989 16.989 0 0 1 1.828 4" />
			<path d="M19.5 17a9 9 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4" />
			<path d="M11.5 21a16.989 16.989 0 0 1 -1.826 -4" />
			<path d="M12.5 21a16.989 16.989 0 0 0 1.828 -4" />
			<path d="M2 10l1 4l1.5 -4l1.5 4l1 -4" />
			<path d="M17 10l1 4l1.5 -4l1.5 4l1 -4" />
			<path d="M9.5 10l1 4l1.5 -4l1.5 4l1 -4" />
		</svg>,
  Sistema: (props: {
    className?: string;
  }) => <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={props.className}>
			<title>Sistema</title>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" />
			<path d="M6 8h.01" />
			<path d="M9 8h.01" />
		</svg>,
  Aplicativo: (props: {
    className?: string;
  }) => <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={props.className}>
			<title>Aplicativo</title>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14" />
			<path d="M11 4h2" />
			<path d="M12 17v.01" />
		</svg>
} satisfies Record<string, ComponentType<{
  className?: string;
}>>;
export function ProposalStepType(t0) {
  const $ = _c(2);
  const {
    control
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = <Controller control={control} name="types" render={_temp} />;
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(t0) {
  const {
    field,
    fieldState
  } = t0;
  return <><div className={proposalChoiceGroupClassName}>{projectTypeOptions.map(option => {
        const Icon = typeIcons[option];
        return <ProposalChoiceCard active={field.value?.includes(option) ?? false} key={option} onClick={() => field.onChange([option])}><Icon /><span>{option}</span></ProposalChoiceCard>;
      })}</div>{fieldState.error && <p className="text-sm text-red-300" data-proposal-animate={true}>{fieldState.error.message}</p>}</>;
}